// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4e261cdf","703":"c57ac799","787":"0bfccc2a"}[chunkId] + ".chunk.js";
};